import React, { Component } from 'react';
import PropTypes from 'prop-types';

import AccountContactList from 'components/ContactList/AccountContactList';
import { getAccountContacts } from 'redux/actions/contactActions';
import { connect } from 'react-redux';
// import Loader from 'components/Loader';

export const DEFAULT_CONTACT_QUERY_PARAMS = {
  active: true,
  detail_page: true,
  exlude_self: false,
};

class ContactsTab extends Component {
  componentDidMount() {
    this.getAccountContacts();
  }

  getAccountContacts = (params = {}) => {
    const accountId = this.props.match.params.id;
    this.props.getAccountContacts(accountId, {
      ...params,
      ...DEFAULT_CONTACT_QUERY_PARAMS,
    });
  }

  render() {
    const { accountContacts } = this.props;
    return (
      <React.Fragment>
        <AccountContactList
          contacts={accountContacts}
          showDuplicates={false}
          showDownloadErrors={false}
          showSteps={false}
          getContacts={this.getAccountContacts}
          showContactReplyForCurrentSequence
        />
      </React.Fragment>
    );
  }
}

ContactsTab.propTypes = {
  getAccountContacts: PropTypes.func.isRequired,
  accountContacts: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
  }).isRequired,
};

export default connect(
  state => ({
    accountContacts: state.accountContacts,
  }),
  {
    getAccountContacts,
  },
)(ContactsTab);
